import React, { useMemo } from 'react';
import { useFieldStyles } from './hooks/useFieldStyles.js';
import { FieldWrap } from './FieldWrap.js';

const SwitchField = React.forwardRef(({ className, invalid, onChange, value: checked, theme, ...props }, ref) => {
    const styles = useFieldStyles({ ...props, invalid, theme, type: 'range' });
    const inputValue = useMemo(() => +checked, [checked]);
    return (React.createElement("div", { className: [
            styles,
            'relative p-reset !rounded-full w-16 h-8',
            invalid ? 'text-red' : 'text-green secondary:text-indigo-500',
            className,
        ].join(' ') },
        React.createElement("input", { className: "absolute w-full h-full left-0 top-0 cursor-pointer opacity-0 peer", type: "checkbox", ...{
                ...props,
                checked,
                invalid: invalid?.toString(),
                ref,
                value: inputValue,
                onChange: e => onChange({
                    ...e,
                    target: {
                        ...e.target,
                        value: !checked,
                    },
                }),
            } }),
        React.createElement("div", { className: [
                theme === 'light' ? 'border border-white' : '',
                'bg-current rounded-full w-8 h-full pointer-events-none transition-transform duration-300 peer-checked:translate-x-[calc(100%-2px)]',
            ].join(' ') })));
});
const SwitchFieldControlled = ({ className, theme, ...props }) => {
    return (React.createElement(FieldWrap, { ...{
            theme,
            ...props,
        } },
        React.createElement(SwitchField, { ...{
                className,
                theme,
            } })));
};

export { SwitchField, SwitchFieldControlled };
//# sourceMappingURL=SwitchField.js.map
